
import react, { useState } from 'react';
import './App.css';
import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';

import {
  BrowserRouter as Router,

  Route,
  Routes,

} from "react-router-dom";



function App() {
const [mode,setMode]=useState("dark"); // whethere dark mode enable or not 

const toggleMode=()=>{
  if(mode === 'light'){
    setMode='dark'
    document.body.style.backgroundColor='grey'
  }else{
    setMode='light'
    document.body.style.backgroundColor='white'
  }
}



  return (
    <>
    <Router>
        <Navbar  title="TextUtils123" abouttext="check about" mode={mode} togglrMode={toggleMode}/>

          <div className="container my-6">
                 <Routes>
                    <Route path='/about' element={ <About/> }>  </Route>

                    <Route path='/' element={<TextForm  heading=" pleace to see text convert  " mode={mode} />}>   </Route>
                 </Routes> 
          </div>
     </Router>
   </>

  );
}

export default App;
